import { USER_DASHBOARD } from "./actionTypes";
import { NOTIFICATION_COUNT } from "./actionTypes";
import { NEWORDER_COUNT } from "./actionTypes";
import { RECEIVEDORDER_COUNT } from "./actionTypes";
import { RECEIVED_RIDE_COUNT } from "./actionTypes";

const defaultState = {
  userdashboard: {},
  notificationcount: 0,
  new_orders: 0,
  receivedordercount: 0,
  receivedRidecount: 0
};

export const reducer = (state = defaultState, action) => {
  
  const {
    type,
    userdashboard,
    notificationcount,
    new_orders,
    receivedordercount,
    receivedRidecount
  } = action;

  switch (type) {
    case USER_DASHBOARD:
      return {
        ...state,
        userdashboard: userdashboard,
      };
    case NOTIFICATION_COUNT:
      return {
        ...state,
        notificationcount: notificationcount,
      };
    case NEWORDER_COUNT:
      return {
        ...state,
        new_orders: new_orders,
      };
    case RECEIVEDORDER_COUNT:
      return {
        ...state,
        receivedordercount: receivedordercount,
      };
    case RECEIVED_RIDE_COUNT:
      return {
         ...state,
         receivedRidecount: receivedRidecount
      }
    default:
      return state;
  }
};

export default reducer;
